<template>
  <article class="hentry post">
    <div class="post__author author vcard inline-items">
      <router-link :to="`/s-app/profile-page/${member.senderId}`">
        <SUserAvatar :myUser="member.sender" size="small" :isProfileAvatar="false" :tryModeratorBadge="true"/>
      </router-link>
      <div class="author-date padding-l">
        <router-link
          :to="`/s-app/profile-page/${member.senderId}`"
          class="post__author-name fn"
        >
          {{ getUserName(member.sender) }}
        </router-link>
        <span class="author-username"> @{{member.sender.username}}</span>
        <div class="post__date">
          <time class="published">{{ member.createdAt | relativeDate }}</time>
        </div>
      </div>
    </div>

    <p class="text-break" data-cy="groupMemberMessage">{{ member.msg }}</p>

    <section>
      <div>
        <CurrentMessageComments :comment="getMessageComments[0]" />
      </div>

      <div v-if="showMore">
        <CurrentMessageComments :comment="comment" v-for="comment in getMessageComments.slice(1)" :key="comment.id"/>
      </div>

      <p class="showMore" v-if="getMessageComments.length > 1" @click="showHideComments"> {{showMore ? '— Show less' : '— Show more'}} ({{getMessageComments.length - 1}})</p>

      <input v-model="text" type="text" placeholder="Add a comment..." class="post-comment" @keyup.enter.exact="sendComment"/>
    </section>
  </article>
</template>

<script>
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import UserHelperVue from "../../mixins/UserHelper.vue";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
import CurrentMessageComments from '@/components/molecules/CurrentMessageComments';
export default {
  name: "GroupMessagesList",
  props: ["member"],
  mixins: [GroupHelperVue, UserHelperVue],
  components: {
    SUserAvatar,
    CurrentMessageComments,
  },
  data() {
    return {
      text: '',
      showMore: false,
    }
  },
  methods: {
    sendComment() {
      try {
        this.sendGroupComment({
          comment: this.text,
          groupMessage: this.member,
        });
        this.text = "";
      } catch (error) {
        console.log(error);
      }
    },
    showHideComments() {
      this.showMore = !this.showMore
    },

  },
  computed: {
    getMessageComments() {
      return this.getCurrentGroupComments.filter((comment) => comment.groupMessageId === this.member.id)
    },
  }
};
</script>

<style scoped>
.author-date {
  display: flex;
  flex-direction: column;
}
.padding-l {
  padding-left: 0.5rem;
}
.avatar-container {
  margin-right: 10px;
  position: relative;
}
.hentry {
  padding-bottom: 10px;
}
.post__author {
  display: flex;
  margin: unset;
}
.post__author-name {
  color: black !important;
  font-weight: 400 !important;
  font-size: 22px;
}
.author-username {
  font-size: 12px;
}
.text-break {
  color: rgb(54, 54, 54);
  margin: unset;
  margin: 10px 0px 15px 45px;
}
.post-comment {
  border-radius: 20px;
  padding: 10px;
}

.showMore {
  margin: unset;
  margin: 0 0 10px 45px;
  cursor: pointer;
}

@media screen and (max-width:1023px) {
  .post__author-name{
    font-size: 18px;
  }
}
</style>
